import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   progress: 0,
};

const syncSlice = createSlice({
   name: 'syncProgressData',
   initialState,
   reducers: {
      setSyncProgress: (state, action) => {
         state.progress = action.payload;
      },
   },
});

export const { setSyncProgress } = syncSlice.actions;
export const syncReducers = {
   syncProgressData: syncSlice.reducer,
};
export const syncReducer = syncSlice.reducer;
